export enum InviteFormFields {
  staff = 'staff',
}

export type InviteFormFieldsValues = {
  [InviteFormFields.staff]: InviteFormFieldsValuesForStaff[];
};

export enum InviteFormFieldsForStaff {
  email = 'email',
}

export type InviteFormFieldsValuesForStaff = {
  [InviteFormFieldsForStaff.email]: string;
};
